import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  Link,
  Drawer,
  CircularProgress,
  Modal,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Collapse from "@mui/material/Collapse";
import Image from "./Image";
import { Stack } from "@mui/material";
import likepost from "../../../../assets/images/postcard/LikePost.svg";
// import sharepost from "../../../../assets/images/postcard/SharePost.svg";
import savepost from "../../../../assets/images/postcard/SavePost.svg";
import twitterbadge from "../../../../assets/images/postcard/Twitter_Verified_Badge 1.svg";
import linkedin from "../../../../assets/images/postcard/Linkedin.svg";
import { createStyledIndicatorButton } from "../../../../common/StyledComponents/SideBarComponents";
import { useDispatch, useSelector } from "react-redux";
import {
  AccountLevelArkchatPermission,
  accountType,
  sellerTypeValue,
} from "../../../../utils/constant";
import moment from "moment";
import ReactPlayer from "react-player";
import likedLogo from "../../../../assets/images/explore/likedLogo.svg";
import bookmarkedLogo from "../../../../assets/images/explore/bookmarkedLogo.svg";
import editIcon from "../../../../assets/images/editTopic.svg";
import { SmallIcon } from "../../../../common/chatComponents/ScreenSearchSection";
import {
  handleViewLikes,
  sellerCollaborate,
  sellerConnect,
} from "../../../../appStore/actions/ArkchatGroup/action";
import ProfileViewModal from "../../../../common/ProfileViewModal";
import ViewLikeDrawer from "./ViewLikeDrawer";
import AlertPopUp from "../../../../common/AlertPopUp";
import { showToastMsg } from "../../../../appStore/actions/global/action";
import { useTranslation } from "react-i18next";
import useAppSelectors from "../../../../customHooks/useAppSelectors";
import MyProfile from "../../../More/MyProfile";
import FirmProfile from "../../../More/FirmProfile";
import CloseIcon from "@mui/icons-material/Close";
import profile_background_logo from "../../../../assets/images/Network.svg";
import profile_logo from "../../../../assets/images/auth/profileimg.svg";
import tickmarkimg from "../../../../assets/images/post/tickMarkIcon.svg";
const SmallActionButton = createStyledIndicatorButton("#E3E1E1");
const clasess = {
  postAction: {
    position: "absolute",
    width: "100%",
    top: "-1.5rem",
    zIndex: "999",

    img: {
      cursor: "pointer",
    },
  },
  abcd: {
    marginLeft: "30px !important",
  },
};

const singleLineMetaSx = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const fullMetaLineSx = {
  display: "block",
  width: "100%",
  whiteSpace: "normal",
  overflow: "visible",
  textOverflow: "unset",
  overflowWrap: "anywhere",
  wordBreak: "break-word",
  lineHeight: 1.35,
};

const PostCard = ({
  postPreviewData,
  type,
  handleSelecteCoreTeam,
  handlePublish,
  setActiveStep,
  handleDeletePostById,
  activeStep,
  handleEditClick,
  handleDeleteClick,
  showBtn = true,
  handleBookmarkClick,
  handleLikeClick,
  previev = true,
  sellerTab,
  showConnect = false,
  isLoading = false,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const [expanded, setExpanded] = useState(false);
  const [isMyProfileDrawerOpen, setMyProfileDrawerOpen] = useState(false);
  const [isFirmProfileDrawerOpen, setFirmProfileDrawerOpen] = useState(false);
  const [isProfileViewOpen, setProfileViewModal] = useState(false);
  const [profileViewData, setProfileViewData] = useState("");
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isViewLikeDarwerOpen, setViewLikeDarwerOpen] = useState(false);
  const [isConnectModalOpen, setConnectModalOpen] = useState(false);
  const [isProfileCompleteModalOpen, setProfileCompleteModalOpen] =
    useState(false);
  const [connectModalAction, setConnectModalAction] = useState("connect");
  const [exploreMediaIndex, setExploreMediaIndex] = useState(0);
  const { currentUserData, accountLevelPeople } = useAppSelectors();
  // const accountLevelPeople = useSelector(
  //   (state) => state?.arkchatgroup?.accountLevelPeople
  // );
  // const userProfileData = useSelector((state) => state?.profile?.profileData);
  const [profileCoreMember, setProfileCoreMember] = useState(
    Object.keys(currentUserData?.activeSubscriber?.coreTeam || {}).length === 0
      ? {
          id: currentUserData?.id,
          pp: currentUserData?.profileImgUrl,
          name: `${currentUserData?.firstName} ${currentUserData?.lastName}`,
          target_subscriber_id: currentUserData?.activeSubscriber?.id,
        }
      : currentUserData?.activeSubscriber?.coreTeam
  );
  const dispatch = useDispatch();
  const exploreAttachments = postPreviewData?.attachments || [];
  const hasConnectAction =
    showConnect &&
    currentUserData?.activeSubscriber?.id !==
      postPreviewData?.userInfo?.activeSubscriber?.id;
  const hasCollaborateAction =
    sellerTab &&
    currentUserData?.activeSubscriber?.id !== postPreviewData?.subscriberId;

  const normalizeMetaText = (value) =>
    typeof value === "string" ? value.trim() : "";

  const getBrandMetaText = (brandInfo) => {
    const brandName = normalizeMetaText(brandInfo?.name);
    const brandWebsite = normalizeMetaText(brandInfo?.website);

    if (!brandName && !brandWebsite) {
      return "";
    }

    if (brandName && brandWebsite) {
      return `Brand : ${brandName} | ${brandWebsite}`;
    }

    if (brandName) {
      return `Brand : ${brandName} |`;
    }

    return `Brand : ${brandWebsite}`;
  };

  const getCombinedMetaLine = (categoryName, brandInfo) =>
    [
      normalizeMetaText(categoryName),
      type === "Product" ? getBrandMetaText(brandInfo) : "",
    ]
      .filter(Boolean)
      .join(" ");

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const NameBadge = createStyledIndicatorButton("#E3E1E1");
  const handleProfileBadgeClick = (
    data,
    isGroup,
    isBuyerSellerGroup = false
  ) => {
    const viewData = {
      companyName: "",
      userName: data?.subscriberInfo?.subscriberFirmName,
      industryName: data?.subscriberInfo?.subscriberAccountIndustry,
      cityName: data?.subscriberInfo?.city,
      countryName: data?.subscriberInfo?.country,
      profileBrief: data?.subscriberInfo?.profileBrief,
      profileImgUrl: data?.subscriberInfo?.profileImgUrl,
      coverImgUrl: data?.subscriberInfo?.coverImgUrl,
      isGroup: isGroup,
      isBuyerSellerGroup: isBuyerSellerGroup,
      website: data?.subscriberInfo?.website,
      linkedin: data?.subscriberInfo?.linkedin,
    };
    setProfileViewData(viewData);
    setProfileViewModal(true);
  };
  const handleViewLike = (id) => {
    dispatch(handleViewLikes(postPreviewData?.id)).then((res) => {
      setViewLikeDarwerOpen(true);
    });
  };
  const isWorkspaceAccount =
    currentUserData?.activeSubscriber?.subscriberPriority ===
    accountType?.Organisation;
  const checkProfileUpdate = () => {
    if (isWorkspaceAccount) {
      return Boolean(
        currentUserData?.activeSubscriber?.subscriberFirmName &&
          currentUserData?.activeSubscriber?.city &&
          currentUserData?.activeSubscriber?.country &&
          currentUserData?.activeSubscriber?.linkedin &&
          currentUserData?.activeSubscriber?.profileBrief
      );
    }
    return Boolean(
      currentUserData?.firstName &&
        currentUserData?.lastName &&
        currentUserData?.city &&
        currentUserData?.country &&
        currentUserData?.linkedin &&
        currentUserData?.profileBrief
    );
  };
  const openRequiredProfileDrawer = () => {
    if (isWorkspaceAccount) {
      setFirmProfileDrawerOpen(true);
      return;
    }
    setMyProfileDrawerOpen(true);
  };
  const handleClickCollab = (post_id) => {
    if (checkProfileUpdate()) {
      dispatch(sellerCollaborate(post_id)).then((res) => {
        if (res?.status) {
          setPopupOpen(true);
        } else {
          dispatch(showToastMsg("Something went wrong !"));
        }
      });
    } else {
      openRequiredProfileDrawer();
    }
  };
  const handleConnectClick = (post_id) => {
    if (checkProfileUpdate()) {
      dispatch(sellerConnect(post_id));
    } else {
      openRequiredProfileDrawer();
    }
  };
  const handleOpenConnectModal = (action = "connect") => {
    setConnectModalAction(action);
    if (!checkProfileUpdate()) {
      setProfileCompleteModalOpen(true);
      return;
    }
    setConnectModalOpen(true);
  };
  const handleContinueProfileUpdate = () => {
    setProfileCompleteModalOpen(false);
    openRequiredProfileDrawer();
  };
  const handleConfirmConnect = () => {
    setConnectModalOpen(false);
    if (connectModalAction === "collaborate") {
      handleClickCollab(postPreviewData?.id);
      return;
    }
    handleConnectClick(postPreviewData?.id);
  };
  const connectProfileData = {
    userName: postPreviewData?.subscriberInfo?.subscriberFirmName,
    industryName: postPreviewData?.subscriberInfo?.subscriberAccountIndustry,
    cityName: postPreviewData?.subscriberInfo?.city,
    countryName: postPreviewData?.subscriberInfo?.country,
    website: postPreviewData?.subscriberInfo?.website,
    linkedin: postPreviewData?.subscriberInfo?.linkedin,
    profileImgUrl: postPreviewData?.subscriberInfo?.profileImgUrl,
    coverImgUrl: postPreviewData?.subscriberInfo?.coverImgUrl,
    accountLabel:
      type === "Product"
        ? postPreviewData?.userInfo?.activeSubscriber?.manufacturer
          ? "Product Manufacturer"
          : sellerTypeValue[
              postPreviewData?.userInfo?.activeSubscriber?.sellerType
            ]
        : "",
  };

  const connectPoints = [
    "A connection request is sent.",
    "When accepted, you both appear in each other's contacts.",
    "You can then chat and collaborate directly on Arkchat.",
  ];

  const collaboratePoints = [
    "A chat group is created so you can start working together instantly.",
    "You and the publisher are added so you can discuss products, services or projects.",
    "Chat, share files, assign tasks and collaborate directly on arkchat.",
  ];

  const modalPoints = 
    connectModalAction === "collaborate" ? collaboratePoints : connectPoints;

  return (
    <>
      <Drawer
        sx={{ zIndex: 1202 }}
        open={isMyProfileDrawerOpen}
        anchor={"right"}
        hideBackdrop={true}
      >
        <MyProfile setMyProfileDrawerOpen={setMyProfileDrawerOpen} />
      </Drawer>
      <Drawer
        sx={{ zIndex: 1202 }}
        open={isFirmProfileDrawerOpen}
        anchor={"right"}
        hideBackdrop={true}
      >
        <FirmProfile setFirmProfileDrawerOpen={setFirmProfileDrawerOpen} />
      </Drawer>
      <ProfileViewModal
        setProfileViewModal={setProfileViewModal}
        isProfileViewOpen={isProfileViewOpen}
        profileViewData={profileViewData}
      />
      <AlertPopUp
        title={"Collaborate"}
        bodyContent={
          "Thank you for your interest in this seller. We have created a Buyer/Seller Group. You can collaborate with the seller in this group."
        }
        open={isPopupOpen}
        closeModal={setPopupOpen}
      />
      <Modal
        open={isProfileCompleteModalOpen}
        onClose={() => setProfileCompleteModalOpen(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "92%", sm: "453px" },
            height: { xs: "auto", sm: "304px" },
            minHeight: { xs: "304px", sm: "304px" },
            bgcolor: "#FFFFFF",
            border: "1px solid #E0E0E0",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          <IconButton
            onClick={() => setProfileCompleteModalOpen(false)}
            sx={{
              position: "absolute",
              top: "28px",
              left: { xs: "20px", sm: "21px" },
              width: "30px",
              height: "30px",
              border: "1px solid #193243",
              borderRadius: "2px",
              bgcolor: "#FFFFFF",
              color: "#193243",
              p: 0,
              "&:hover": { bgcolor: "#FFFFFF" },
            }}
          >
            <CloseIcon sx={{ fontSize: "24px" }} />
          </IconButton>
          <Typography
            sx={{
              position: "absolute",
              top: "28px",
              left: { xs: "70px", sm: "72px" },
              width: "265px",
              height: "24px",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 400,
              fontSize: "16px",
              lineHeight: "24px",
              letterSpacing: "0px",
              color: "#000000",
            }}
          >
            Complete your profile to{" "}
            {connectModalAction === "collaborate"
              ? "collaborate"
              : "connect"}
          </Typography>

          <Typography
            sx={{
              position: "absolute",
              top: "82px",
              left: { xs: "38px", sm: "78px" },
              width: { xs: "calc(100% - 76px)", sm: "376px" },
              height: "63px",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "21px",
              letterSpacing: "0px",
              color: "#000000",
            }}
          >
            To help others know who they are{" "}
            {connectModalAction === "collaborate"
              ? "collaborating"
              : "connecting"}{" "}
            with, please complete your profile.
            <br />
            <br />
            This helps build trust and improves your chances of getting a
            response.
          </Typography>

          <Button
            variant="outlined"
            onClick={handleContinueProfileUpdate}
            sx={{
              position: "absolute",
              top: "214px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "117px",
              height: "44px",
              border: "0.5px solid #000000",
              borderRadius: "2px",
              color: "#000000",
              textTransform: "none",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "21px",
              letterSpacing: "0px",
              "&:hover": {
                border: "0.5px solid #000000",
                backgroundColor: "#FFFFFF",
              },
            }}
          >
            Continue
          </Button>
          <Typography
            sx={{
              position: "absolute",
              top: "268px",
              left: 0,
              width: "100%",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0px",
              color: "#000000",
              textAlign: "center",
            }}
          >
            Takes less than a minute
          </Typography>
        </Box>
      </Modal>
      <Modal
        open={isConnectModalOpen}
        onClose={() => setConnectModalOpen(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "92%", sm: "487px" },
            maxHeight: "calc(100dvh - 16px)",
            overflow: "hidden",
            bgcolor: "#FFFFFF",
            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.25)",
            borderRadius: "10px",
          }}
        >
          <Box position={"relative"}>
            <Box
              sx={{
                height: { xs: 118, sm: "138px", md: "156px" },
                "@media (max-height: 820px)": {
                  height: { xs: 110, sm: "126px", md: "138px" },
                },
                "@media (min-height: 820px)": {
                  height: { xs: 160, sm: "187px" },
                },
                overflow: "hidden",
              }}
            >
              <img
                src={connectProfileData?.coverImgUrl || profile_background_logo}
                alt="cover"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Box>
            <IconButton
              onClick={() => setConnectModalOpen(false)}
              sx={{
                position: "absolute",
                top: 14,
                left: 18,
                width: "30px",
                height: "30px",
                bgcolor: "#FFFFFF",
                borderRadius: "4px",
                border: "none",
                boxShadow: "none",
                "&:hover": { bgcolor: "#FFFFFF" },
              }}
            >
              <CloseIcon sx={{ color: "#193243", fontSize: "20px" }} />
            </IconButton>
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                bottom: { xs: -32, sm: -40 },
                transform: "translateX(-50%)",
                overflow: "visible",
                display: "flex",
                alignItems: "center",
                width: { xs: 72, sm: "84px", md: "96px" },
                height: { xs: 72, sm: "84px", md: "96px" },
                "@media (max-height: 820px)": {
                  bottom: { xs: -28, sm: -34 },
                  width: { xs: 66, sm: "76px", md: "86px" },
                  height: { xs: 66, sm: "76px", md: "86px" },
                },
                "@media (min-height: 820px)": {
                  bottom: { xs: -44, sm: -63 },
                  width: { xs: 92, sm: "126.45px" },
                  height: { xs: 92, sm: "126px" },
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  bgcolor: connectProfileData?.profileImgUrl
                    ? "#000000"
                    : "#EAEAEA",
                  borderRadius: "5px",
                  overflow: "hidden",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.28)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={connectProfileData?.profileImgUrl || profile_logo}
                  alt="profile"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: connectProfileData?.profileImgUrl
                      ? "cover"
                      : "contain",
                    padding: connectProfileData?.profileImgUrl ? "0" : "10px",
                  }}
                />
              </Box>
              {connectProfileData?.linkedin && (
                <Link
                  href={
                    connectProfileData?.linkedin?.startsWith("http")
                      ? connectProfileData?.linkedin
                      : `https://${connectProfileData?.linkedin}`
                  }
                  target="_blank"
                  rel="noopener"
                  sx={{
                    position: "absolute",
                    left: "calc(100% + 8px)",
                    top: "72%",
                    transform: "translateY(-50%)",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={linkedin}
                    alt="linkedin"
                    style={{ width: "30px", height: "30px" }}
                  />
                </Link>
              )}
            </Box>
          </Box>

          <Box
            sx={{
              pt: { xs: 5.5, sm: "60px" },
              px: { xs: 2.5, sm: "21.5px" },
              pb: { xs: 2.5, sm: "14px" },
              textAlign: "center",
              "@media (max-height: 820px)": {
                pt: { xs: 5, sm: "54px" },
                pb: 1.5,
              },
              "@media (min-height: 820px)": {
                pt: { xs: 7, sm: "78px" },
                pb: { xs: 4, sm: "24px" },
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: { xs: "6px", sm: "8px" },
                "@media (min-height: 820px)": {
                  mb: "10px",
                },
              }}
            >
              <Typography
                sx={{
                  maxWidth: "220px",
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "20px",
                  letterSpacing: "0px",
                  color: "#000000",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {connectProfileData?.userName}
              </Typography>
            </Box>

            {connectProfileData?.website && (
              <Link
                href={
                  connectProfileData?.website?.startsWith("http")
                    ? connectProfileData?.website
                    : `https://${connectProfileData?.website}`
                }
                target="_blank"
                rel="noopener"
                underline="none"
              >
                <Typography
                  sx={{
                    maxWidth: "220px",
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "16px",
                    letterSpacing: "0px",
                    textAlign: "center",
                    color: "#2C86FF",
                    textDecoration: "underline",
                    mb: { xs: "6px", sm: "8px" },
                    mx: "auto",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    "@media (min-height: 820px)": {
                      mb: "14px",
                    },
                  }}
                >
                  {connectProfileData?.website}
                </Typography>
              </Link>
            )}

            <Typography
              sx={{
                width: "243px",
                maxWidth: "100%",
                mx: "auto",
                mb: { xs: "2px", sm: "4px" },
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "18px",
                letterSpacing: "0px",
                color: "#000000",
                textAlign: "center",
                "@media (min-height: 820px)": {
                  mb: "8px",
                },
              }}
            >
              {connectProfileData?.industryName}
            </Typography>
            <Typography
              sx={{
                mb: { xs: "2px", sm: "4px" },
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "18px",
                letterSpacing: "0px",
                color: "#000000",
                textAlign: "center",
                "@media (min-height: 820px)": {
                  mb: "8px",
                },
              }}
            >
              {connectProfileData?.cityName}, {connectProfileData?.countryName}
            </Typography>
            {connectProfileData?.accountLabel && (
              <Typography
                sx={{
                  mb: { xs: "8px", sm: "10px" },
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 400,
                  fontSize: "12px",
                  lineHeight: "18px",
                  letterSpacing: "0px",
                  color: "#000000",
                  textAlign: "center",
                  "@media (min-height: 820px)": {
                    mb: "24px",
                  },
                }}
              >
                {connectProfileData?.accountLabel}
              </Typography>
            )}

            <Typography
              sx={{
                mt: { xs: "8px", sm: "10px" },
                mb: { xs: "6px", sm: "8px" },
                fontFamily: "Poppins, sans-serif",
                fontWeight: 500,
                fontSize: "13px",
                lineHeight: "100%",
                letterSpacing: "0px",
                color: "#000000",
                textAlign: "center",
                "@media (min-height: 820px)": {
                  mt: "30px",
                  mb: "18px",
                },
              }}
            >
              {connectModalAction === "collaborate"
                ? "What happens when you collaborate?"
                : "What happens when you connect?"}
            </Typography>

            <Box
              sx={{
                width: { xs: "100%", sm: "444px" },
                mx: "auto",
                mb: "0px",
                px: { xs: 2, sm: "18px" },
                pt: { xs: 0.5, sm: "6px" },
                pb: "0px",
                textAlign: "left",
                boxSizing: "border-box",
                "@media (max-height: 820px)": {
                  pt: { xs: 0, sm: "2px" },
                },
                "@media (min-height: 820px)": {
                  minHeight: { xs: "auto", sm: "195px" },
                  pt: { xs: 2, sm: "18px" },
                },
              }}
            >
              {modalPoints.map((point, index) => (
                <Box
                  key={point}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "10px",
                    mb: index === modalPoints.length - 1 ? 0 : "6px",
                    "@media (max-height: 820px)": {
                      mb: index === modalPoints.length - 1 ? 0 : "4px",
                    },
                    "@media (min-height: 820px)": {
                      mb: index === modalPoints.length - 1 ? 0 : "10px",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      minWidth: "11px",
                      mt: "3px",
                      fontSize: "12px",
                      lineHeight: "10px",
                      color: "#183243",
                    }}
                  >
                    {<img src={tickmarkimg} alt="Tick mark" />}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 400,
                      fontSize: "12px",
                      lineHeight: "16px",
                      letterSpacing: "0px",
                      color: "#000000",
                    }}
                  >
                    {point}
                  </Typography>
                </Box>
              ))}
            </Box>

            <Button
              variant="outlined"
              onClick={handleConfirmConnect}
              sx={{
                width: "216px",
                height: "44px",
                mt: { xs: "10px", sm: "12px" },
                border: "0.5px solid #000000",
                borderRadius: "2px",
                color: "#000000",
                textTransform: "none",
                fontSize: "14px",
                "&:hover": {
                  border: "0.5px solid #000000",
                  backgroundColor: "#FFFFFF",
                },
                "@media (min-height: 820px)": {
                  mt: "8px",
                },
              }}
            >
              <Typography
                sx={{
                  minWidth: "61px",
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 500,
                  fontSize: "14px",
                  lineHeight: "100%",
                  letterSpacing: "0px",
                  color: "#000000",
                  textAlign: "center",
                }}
              >
                {connectModalAction === "collaborate"
                  ? "Collaborate"
                  : "Connect"}
              </Typography>
            </Button>

            <Typography
              sx={{
                width: "294px",
                maxWidth: "100%",
                mx: "auto",
                mt: { xs: "8px", sm: "10px" },
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
                fontSize: "13px",
                lineHeight: "18px",
                letterSpacing: "0px",
                color: "#000000",
                textAlign: "center",
                "@media (max-height: 820px)": {
                  mt: { xs: "6px", sm: "8px" },
                },
                "@media (min-height: 820px)": {
                  mt: "40px",
                },
              }}
            >
              {connectModalAction === "collaborate"
                ? "Collaborate to start working together on Arkchat."
                : "Connect to start collaborating on Arkchat."}
            </Typography>
          </Box>
        </Box>
      </Modal>
      {postPreviewData?.post && previev ? (
        <Box>
          <Card sx={{ maxWidth: 455, margin: "auto" }}>
            {type === "Videos" ? (
              <Box height={"21.8rem"}>
                <ReactPlayer
                  width="100%"
                  height="95%"
                  url={`${postPreviewData?.post?.attachments[0]?.location}`}
                  controls={true}
                  volume={null}
                  muted={true}
                  config={{
                    youtube: {
                      playerVars: {
                        controls: 1,
                        mute: 1,
                        showinfo: 0,
                      },
                    },
                    file: {
                      attributes: {
                        controlsList: "nodownload",
                      },
                    },
                  }}
                />
              </Box>
            ) : (
              <Image
                images={
                  postPreviewData?.post?.attachments?.length > 0 &&
                  postPreviewData?.post?.attachments
                }
              />
            )}

            <Box position={"relative"}>
              <Stack
                alignItems="center"
                direction="row"
                justifyContent={"space-between"}
                sx={clasess.postAction}
                bgcolor={"#F3F3F3"}
                padding={"0.2rem 0.4rem"}
              >
                <Stack alignItems="center" direction="row" spacing={2}>
                  <Box>
                    <img src={likepost} alt="like_icon" />
                  </Box>
                  {/* <Box>
                    <img src={sharepost} alt="share_icon" className="ml-30" />
                  </Box> */}
                  {/* <Box>
                    <img src={emailpost} alt="email_icon" />
                  </Box> */}
                  {/* <Box>
                    {" "}
                    <img src={actionpost} alt="action_icon" />
                  </Box> */}
                </Stack>
                <Stack>
                  <img src={savepost} alt="action_icon" />
                </Stack>
              </Stack>
            </Box>
            <CardContent>
              <Box display={"flex"} justifyContent={"space-between"}>
                <Box>
                  <Typography variant="h6" fontWeight={500} fontSize={"14px"}>
                    {type}
                  </Typography>
                </Box>
                {type === "Product" && (
                  <Box>
                    <Typography
                      variant="h6"
                      fontWeight={500}
                      fontSize={"14px"}
                      sx={singleLineMetaSx}
                    >
                      {postPreviewData?.userDetails?.activeSubscriber
                        ?.manufacturer
                        ? "Manufacturer"
                        : sellerTypeValue[
                            postPreviewData?.userDetails?.activeSubscriber
                              ?.sellerType
                          ]}
                    </Typography>
                  </Box>
                )}
              </Box>

              <Box>
                <Typography
                  variant="h6"
                  fontWeight={400}
                  fontSize={"14px"}
                  sx={fullMetaLineSx}
                >
                  {getCombinedMetaLine(
                    postPreviewData?.post?.category?.map?.(c => c.name)?.join(', '),
                    postPreviewData?.post?.brandInfo
                  )}
                </Typography>
              </Box>

              <Box padding={"10px 0"}>
                <Box>
                  <Typography fontSize={"12px"} fontWeight={600} variant="h6">
                    {postPreviewData?.post?.postData?.title}
                  </Typography>
                </Box>
                <span>
                  <Typography variant="body2">
                    {!expanded &&
                      postPreviewData?.post?.postData?.description?.slice(
                        0,
                        100
                      ) + " ..."}{" "}
                    <>
                      {postPreviewData?.post?.postData?.description?.length >
                        100 &&
                        !expanded && (
                          <span
                            onClick={handleExpandClick}
                            style={{
                              fontSize: "0.875rem",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            {expanded ? "...less" : "more"}
                          </span>
                        )}
                    </>
                  </Typography>
                  <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <Typography variant="body2">
                      {postPreviewData?.post?.postData?.description}
                      <span
                        onClick={handleExpandClick}
                        style={{
                          fontSize: "0.875rem",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        {expanded ? "...less" : "more"}
                      </span>
                    </Typography>
                  </Collapse>
                </span>
              </Box>
              {/* <Typography fontWeight={600} fontSize={"14px"} paddingBottom={"10px"}>
            {" "}
            Illustrations for social media post
          </Typography> */}

              <Box>
                <Box display="flex" alignItems="flex-start" gap={"0.5rem"}>
                  <SmallActionButton
                    size="small"
                    variant="contained"
                    sx={{ mr: "4px" }}
                  >
                    <>
                      {postPreviewData?.userDetails?.activeSubscriber
                        ?.profileImgUrl ? (
                        <img
                          style={{ width: "100%", height: "100%" }}
                          src={
                            postPreviewData?.userDetails?.activeSubscriber
                              ?.profileImgUrl
                          }
                          alt=""
                        />
                      ) : (
                        <Typography
                          variant="h6"
                          fontSize={"0.75rem"}
                          color={"#183243"}
                        >
                          {postPreviewData?.userDetails?.activeSubscriber
                            ?.subscriberFirmName &&
                            postPreviewData?.userDetails?.activeSubscriber
                              ?.subscriberFirmName[0]}
                        </Typography>
                      )}
                    </>
                  </SmallActionButton>
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    width={"100%"}
                  >
                    <Stack direction={"column"} spacing={"0.2rem"}>
                      <Box maxWidth={"95%"}>
                        <Typography
                          fontSize="14px"
                          fontWeight="600 !important"
                          color={"black"}
                          variant="h6"
                          width={"min-content"}
                          sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <Stack direction={"row"} gap={"5px"}>
                            {
                              postPreviewData?.userDetails?.activeSubscriber
                                ?.subscriberFirmName
                            }
                            <img
                              src={twitterbadge}
                              title="Twitter Status"
                              alt=""
                            />
                          </Stack>
                        </Typography>
                      </Box>
                      <Box maxWidth={"95%"}>
                        <Typography
                          sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          fontSize="14px"
                          fontWeight="400"
                          color={"black"}
                          variant="h6"
                          lineHeight={1}
                        >
                          {
                            postPreviewData?.userDetails?.activeSubscriber
                              ?.subscriberAccountIndustry
                          }
                        </Typography>
                      </Box>

                      <Box maxWidth={"95%"}>
                        <Typography
                          sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          fontSize="14px"
                          fontWeight="400"
                          color={"black"}
                          variant="h6"
                        >
                          {postPreviewData?.userDetails?.activeSubscriber?.city}
                          ,{" "}
                          {
                            postPreviewData?.userDetails?.activeSubscriber
                              ?.countryCode
                          }
                        </Typography>
                      </Box>

                      <Typography
                        sx={{ textDecoration: "underline" }}
                        fontSize={"14px"}
                        display={"inline"}
                      >
                        {
                          postPreviewData?.userDetails?.activeSubscriber
                            ?.website
                        }
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>
              </Box>
            </CardContent>
            {showBtn && (
              <Box
                sx={{ display: "flex", justifyContent: "center", gap: "5px" }}
                mb={"0.5rem"}
              >
                <Box>
                  <Button
                    onClick={() => {
                      setActiveStep(1);
                      localStorage.setItem(
                        "post_id",
                        JSON.stringify(postPreviewData?.post?.id)
                      );
                      localStorage.setItem("isEditPost", JSON.stringify(true));
                    }}
                    variant="outlined"
                    sx={{
                      borderRadius: "2px",
                      color: "#000000",
                      border: "1px solid #000000",
                      ":hover": {
                        color: "#000000",
                        border: "1px solid #000000",
                      },
                      textTransform: "none",
                    }}
                  >
                    Edit
                  </Button>
                </Box>
                <Box>
                  <Button
                    onClick={() => {
                      localStorage.setItem(
                        "post_id",
                        JSON.stringify(postPreviewData?.post?.id)
                      );
                      handleDeletePostById();
                    }}
                    variant="outlined"
                    sx={{
                      borderRadius: "2px",
                      color: "#000000",
                      border: "1px solid #000000",
                      ":hover": {
                        color: "#000000",
                        border: "1px solid #000000",
                      },
                      textTransform: "none",
                    }}
                  >
                    Delete
                  </Button>
                </Box>
                <Box>
                  <Button
                    onClick={!isLoading ? handlePublish : null}
                    variant="outlined"
                    sx={{
                      borderRadius: "2px",
                      border: "1px solid #DB0011",
                      backgroundColor: "#DB0011",
                      color: "white",
                      ":hover": {
                        border: "1px solid #DB0011",
                        backgroundColor: "#DB0011",
                        color: "white",
                      },
                      textTransform: "none",
                    }}
                  >
                    {isLoading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      appContent?.KEY4
                    )}
                  </Button>
                </Box>
              </Box>
            )}
          </Card>

          <Box
            position={"absolute"}
            top={"2rem"}
            right={0}
            height={"80vh"}
            maxHeight={"80vh"}
            padding={"0rem 1.5rem"}
            boxShadow={"0px 0px 2px rgba(0, 0, 0, 0.25)"}
          >
            {/* Core Team BOX */}
            <Box mb={"0.4rem"} mt={"0.4rem"}>
              <Typography>Who will receive messages</Typography>
            </Box>
            {accountLevelPeople?.internalMember?.length > 0 &&
              accountLevelPeople?.internalMember
                ?.filter(
                  (item) =>
                    item.inviteType !== 2 &&
                    (item?.permission ===
                      AccountLevelArkchatPermission?.ADMIN ||
                      item?.permission ===
                        AccountLevelArkchatPermission?.MANAGER)
                )
                .map((userData) => (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                    mt={""}
                    key={userData?.userId + "PostCard"}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 30,
                              color: "#183243",
                            },
                          }}
                          onChange={(e) =>
                            handleSelecteCoreTeam(
                              e,
                              userData,
                              setProfileCoreMember,
                              profileCoreMember
                            )
                          }
                          checked={profileCoreMember?.id === userData?.userId}
                          icon={
                            <NameBadge
                              sx={{ color: "#183243" }}
                              size="small"
                              variant="contained"
                            >
                              <Typography color={"#183243"}>
                                {userData?.userInfo?.firstName &&
                                  userData?.userInfo?.firstName[0]}
                              </Typography>
                            </NameBadge>
                          }
                        />
                      }
                      label={`${userData?.userInfo?.firstName} ${userData?.userInfo?.lastName}`}
                    />
                  </Stack>
                ))}
          </Box>
        </Box>
      ) : (
        <>
          {/* Manage Post */}
          <Box>
            <Card
              sx={{
                maxWidth: 455,
                margin: "auto",
                borderRadius: 0,
                boxShadow: "none",
                border: "1px solid #D9D9D9",
              }}
            >
              <Box
                px={"0.75rem"}
                py={"0.6rem"}
                borderBottom={"1px solid #D9D9D9"}
                display="flex"
                alignItems="flex-start"
                gap={"0.5rem"}
              >
                <SmallActionButton
                  sx={{
                    width: "28px",
                    height: "28px",
                    minWidth: "28px",
                    padding: postPreviewData?.subscriberInfo?.profileImgUrl
                      ? "0px"
                      : "6px",
                    overflow: "hidden",
                    color: "#183243",
                    mr: "2px",
                    borderRadius: "2px",
                  }}
                  size="small"
                  variant="contained"
                  onClick={() => handleProfileBadgeClick(postPreviewData)}
                >
                  <>
                    {postPreviewData?.subscriberInfo?.profileImgUrl ? (
                      <img
                        style={{ width: "100%", height: "100%" }}
                        src={postPreviewData?.subscriberInfo?.profileImgUrl}
                        alt=""
                      />
                    ) : (
                      <Typography
                        variant="h6"
                        fontSize={"0.75rem"}
                        color={"#183243"}
                      >
                        {postPreviewData?.subscriberInfo?.subscriberFirmName &&
                          postPreviewData?.subscriberInfo?.subscriberFirmName[0]}
                      </Typography>
                    )}
                  </>
                </SmallActionButton>

                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  width={"100%"}
                  spacing={1}
                >
                  <Stack
                    width={"100%"}
                    direction={"column"}
                    spacing={"0.1rem"}
                    minWidth={0}
                  >
                    <Box maxWidth={"100%"}>
                      <Typography
                        fontSize="14px"
                        fontWeight="600 !important"
                        color={"black"}
                        variant="h6"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        {postPreviewData?.subscriberInfo?.subscriberFirmName}
                        {postPreviewData?.subscriberInfo?.isAccountVerified && (
                          <img
                            src={twitterbadge}
                            title="Twitter Status"
                            alt=""
                          />
                        )}
                      </Typography>
                    </Box>
                    <Box maxWidth={"100%"}>
                      <Typography
                        fontSize="12px"
                        fontWeight="400"
                        color={"black"}
                        variant="h6"
                        lineHeight={1.2}
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {postPreviewData?.subscriberInfo?.subscriberAccountIndustry}
                      </Typography>
                    </Box>

                    <Box maxWidth={"100%"}>
                      <Typography
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        fontSize="12px"
                        fontWeight="400"
                        color={"black"}
                        variant="h6"
                      >
                        {postPreviewData?.subscriberInfo?.city},{" "}
                        {postPreviewData?.subscriberInfo?.countryCode}
                      </Typography>
                    </Box>
                  </Stack>
                </Stack>
              </Box>

              {type === "Videos" ? (
                <Box height={"21.8rem"}>
                  <ReactPlayer
                    width="100%"
                    height="95%"
                    url={`${postPreviewData?.attachments[0]?.location}`}
                    controls={true}
                    volume={null}
                    muted={true}
                    config={{
                      youtube: {
                        playerVars: {
                          mute: 1,
                          modestbranding: 1,
                          controls: 1,
                          disablekb: 1,
                          enablejsapi: 1,
                          iv_load_policy: 3,
                          rel: 0,
                          showinfo: 0,
                        },
                      },
                      file: {
                        attributes: {
                          controlsList: "nodownload",
                        },
                      },
                    }}
                  />
                </Box>
              ) : (
                <Box>
                  <Image
                    images={
                      postPreviewData?.attachments?.length > 0 &&
                      postPreviewData?.attachments
                    }
                    showIndicators={false}
                    onChange={(currentIndex) =>
                      setExploreMediaIndex(currentIndex || 0)
                    }
                  />
                </Box>
              )}

              <Box
                borderTop={"1px solid #D9D9D9"}
                borderBottom={"1px solid #D9D9D9"}
              >
                <Stack
                  alignItems="center"
                  direction="row"
                  justifyContent={"space-between"}
                  bgcolor={"#FFFFFF"}
                  padding={"0.45rem 0.75rem"}
                >
                  <Box
                    sx={{
                      minWidth: "56px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      onClick={
                        showBtn
                          ? null
                          : () => handleLikeClick(postPreviewData?.id)
                      }
                    >
                      {showBtn ? (
                        <img src={likepost} alt="like_icon" />
                      ) : (
                        <img
                          src={postPreviewData?.isLiked ? likedLogo : likepost}
                          alt="like_icon"
                        />
                      )}
                    </Box>
                    <Drawer
                      sx={{ zIndex: 1202 }}
                      open={isViewLikeDarwerOpen}
                      anchor={"right"}
                    >
                      <ViewLikeDrawer
                        setViewLikeDarwerOpen={setViewLikeDarwerOpen}
                      />
                    </Drawer>
                  </Box>

                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    {type !== "Videos" &&
                      exploreAttachments?.length > 1 &&
                      exploreAttachments.map((_, index) => (
                        <Box
                          key={`${postPreviewData?.id}-dot-${index}`}
                          sx={{
                            width: "5px",
                            height: "5px",
                            borderRadius: "50%",
                            backgroundColor:
                              exploreMediaIndex === index
                                ? "#183243"
                                : "rgba(0, 0, 0, 0.32)",
                          }}
                        />
                      ))}
                  </Box>

                  <Stack
                    alignItems="center"
                    direction="row"
                    spacing={2}
                    sx={{ minWidth: "56px", justifyContent: "flex-end" }}
                  >
                    {currentUserData?.id === postPreviewData?.userId && (
                      <Box
                        onClick={() => {
                          handleEditClick(postPreviewData);
                          localStorage.setItem(
                            "isEditPost",
                            JSON.stringify(true)
                          );
                        }}
                      >
                        <SmallIcon src={editIcon} />
                      </Box>
                    )}

                    <Box
                      onClick={
                        showBtn
                          ? null
                          : () => handleBookmarkClick(postPreviewData?.id)
                      }
                    >
                      <img
                        src={
                          postPreviewData?.isBookmarked
                            ? bookmarkedLogo
                            : savepost
                        }
                        alt="action_icon"
                      />
                    </Box>
                  </Stack>
                </Stack>
              </Box>
              <CardContent sx={{ px: "0.75rem", py: "0.75rem !important" }}>
                <Box>
                  <Box>
                    <Box width={"100%"}>
                      <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"flex-start"}
                        spacing={1}
                      >
                        <Box flex={1} minWidth={0}>
                          <Typography
                            variant="h6"
                            fontWeight={400}
                            fontSize={"15px"}
                          >
                            {type}
                          </Typography>
                          {type === "Product" && (
                            <Box>
                              <Typography
                                variant="h6"
                                fontWeight={600}
                                fontSize={"14px"}
                                sx={singleLineMetaSx}
                              >
                                {postPreviewData?.userInfo?.activeSubscriber
                                  ?.manufacturer
                                  ? "Manufacturer"
                                  : sellerTypeValue[
                                      postPreviewData?.userInfo
                                        ?.activeSubscriber?.sellerType
                                    ]}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        {(hasConnectAction || hasCollaborateAction) && (
                          <Stack
                            spacing={1}
                            alignItems={"flex-end"}
                            flexShrink={0}
                          >
                            {hasConnectAction && (
                              <Button
                                variant="outlined"
                                sx={{
                                  padding: "0.1rem 0.55rem",
                                  borderRadius: "2px",
                                  border: "1px solid #000000",
                                  backgroundColor: "#fff",
                                  color: "black",
                                  ":hover": {
                                    border: "1px solid #000000",
                                    backgroundColor: "#fff",
                                    color: "black",
                                  },
                                  textTransform: "none",
                                  minWidth: "unset",
                                  fontSize: "14px",
                                }}
                                onClick={() =>
                                  handleOpenConnectModal("connect")
                                }
                              >
                                Connect
                              </Button>
                            )}
                            {hasCollaborateAction && (
                              <Button
                                variant="outlined"
                                sx={{
                                  borderRadius: "2px",
                                  border: "1px solid #000000",
                                  backgroundColor: "#fff",
                                  color: "black",
                                  ":hover": {
                                    border: "1px solid #000000",
                                    backgroundColor: "#fff",
                                    color: "black",
                                  },
                                  textTransform: "none",
                                }}
                                onClick={() =>
                                  handleOpenConnectModal("collaborate")
                                }
                              >
                                Collaborate
                              </Button>
                            )}
                          </Stack>
                        )}
                      </Stack>

                      <Box width={"100%"}>
                        <Typography
                          variant="h6"
                          fontWeight={400}
                          fontSize={"14px"}
                          sx={fullMetaLineSx}
                        >
                          {getCombinedMetaLine(
                            postPreviewData?.category?.map?.(c => c.name)?.join(', '),
                            postPreviewData?.brandInfo
                          )}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box padding={"8px 0 0"}>
                  <Box>
                    <Typography fontSize={"14px"} fontWeight={600} variant="h6">
                      {postPreviewData?.postData?.title}
                    </Typography>
                  </Box>
                  <span>
                    <Typography variant="body2" sx={{ lineHeight: 1.45 }}>
                      {!expanded &&
                        postPreviewData?.postData?.description.slice(0, 100) +
                          (postPreviewData?.postData?.description.length > 100
                            ? " ..."
                            : "")}
                      <>
                        {postPreviewData?.postData?.description.length > 100 &&
                          !expanded && (
                            <span
                              onClick={handleExpandClick}
                              style={{
                                fontSize: "0.875rem",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                            >
                              {expanded ? "...less" : "more"}
                            </span>
                          )}
                      </>
                    </Typography>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                      <Typography variant="body2">
                        {postPreviewData?.postData?.description}
                        <span
                          onClick={handleExpandClick}
                          style={{
                            fontSize: "0.875rem",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          {expanded ? "...less" : "more"}
                        </span>
                      </Typography>
                    </Collapse>
                  </span>
                </Box>
              </CardContent>
              <>
                {showBtn && (
                  <>
                    <Box textAlign={"center"} mb={"0.5rem"}>
                      <Typography>
                        Posted by {postPreviewData?.postData?.postBy} {"|"}{" "}
                        {moment(postPreviewData?.createdAt).format(
                          "DD-MM-YYYY"
                        )}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "5px",
                      }}
                      mb={"0.5rem"}
                    >
                      <Box>
                        <Button
                          onClick={() => {
                            handleEditClick(postPreviewData);
                            localStorage.setItem(
                              "isEditPost",
                              JSON.stringify(true)
                            );
                          }}
                          variant="outlined"
                          sx={{
                            borderRadius: "2px",
                            color: "#000000",
                            border: "1px solid #000000",
                            ":hover": {
                              color: "#000000",
                              border: "1px solid #000000",
                            },
                            textTransform: "none",
                          }}
                        >
                          Edit
                        </Button>
                      </Box>
                      <Box>
                        <Button
                          onClick={() => handleDeleteClick(postPreviewData?.id)}
                          variant="outlined"
                          sx={{
                            borderRadius: "2px",
                            color: "#000000",
                            border: "1px solid #000000",
                            ":hover": {
                              color: "#000000",
                              border: "1px solid #000000",
                            },
                            textTransform: "none",
                          }}
                        >
                          Delete
                        </Button>
                      </Box>
                      <Box display={"none"}>
                        <Button
                          onClick={!isLoading ? handlePublish : null}
                          variant="outlined"
                          sx={{
                            borderRadius: "2px",
                            border: "1px solid #DB0011",
                            backgroundColor: "#DB0011",
                            color: "white",
                            ":hover": {
                              border: "1px solid #DB0011",
                              backgroundColor: "#DB0011",
                              color: "white",
                            },
                            textTransform: "none",
                          }}
                        >
                          {isLoading ? (
                            <CircularProgress size={24} color="inherit" />
                          ) : (
                            appContent?.KEY4
                          )}
                        </Button>
                      </Box>
                    </Box>
                  </>
                )}
              </>
            </Card>
          </Box>
        </>
      )}
    </>
  );
};

export default PostCard;
